export default function formatToDouble(value) {
    if(!value)
        return 0;
    let val = value.replace('.', '').replace(',', '.')
    return parseFloat(val)
}